
// file Route & run app integration

import routing from './integrationPanel.route';
import run from './integrationPanel.run';

// tablas de integracion y datos cargados
import tablesint from './tablesint';
import tables from './tables';

// controllers & services module Users
import executeDataController from './integration_action/execute/executeDataController';
import integrationServices from './integrationServices';
import GlobalConfig from '../../globals/globalConfig.json'

export default angular.module('app.executionPanel', [integrationServices,tablesint,tables])
  .config(routing)
  .controller('executeDataController', executeDataController)
  .run(run)
  .constant("ExecutionIntegrationPanel", [
     {
        "title": "Data-Integration",
        "icon":"mdi-action-perm-contact-cal",
        "subMenu":[
                  {
                  'title' : 'Ejecutar integración de datos',
                  'url':   'app.integracion',
                  'rolesAllowed': [GlobalConfig.userRolesIds.generalAdmin]
                  
                  }
              ]
    }])
  .name;





// WEBPACK FOOTER //
// ./src/app/integration-front/index.js